import { useEffect, useState, type FunctionComponent } from 'react';

import FormGroup from '@helsenorge/designsystem-react/components/FormGroup';
import Toggle from '@helsenorge/designsystem-react/components/Toggle';

const CHUNK_SIZE = 20;

interface LazyToggleListProps {
  legend: string;
  options: string[];
  selected?: string[];
  onToggle: (value: string) => void;
}

export const LazyToggleList: FunctionComponent<LazyToggleListProps> = ({ legend, options, selected, onToggle }) => {
  const [visibleOptionCount, setVisibleOptionCount] = useState(CHUNK_SIZE);

  useEffect(() => {
    if (visibleOptionCount >= options.length) {
      return;
    }

    const timeout = setTimeout(() => setVisibleOptionCount(count => count + CHUNK_SIZE), 0);

    return (): void => clearTimeout(timeout);
  }, [options.length, visibleOptionCount]);

  return (
    <FormGroup legend={legend}>
      {options.slice(0, visibleOptionCount).map(option => (
        <Toggle key={option} label={[{ text: option }]} checked={selected?.includes(option) ?? false} onChange={() => onToggle(option)} />
      ))}
    </FormGroup>
  );
};
